<template>
    <div class="app-header">

        <nav class="navbar is-light">

            <div id="NotifyBackground">
                <div @click="NotifyControl()" v-if="NotifyBackground" id="NotifyArea" style="opacity: 0.9; text-align: right; padding-right: 0; background-color: black; position: absolute; width:2520px; height: 1280px; max-height: 1280px; margin-top: 10px; z-index: 900">
                </div>
            </div>

            <div class="navbar-brand">
                <div class="navbar-item">
                        <router-link class="navbar-item" :to="{ name: 'DashboardPage' }" active-class="is-active">
                            <img src="@/assets/images/logo.svg" height="20" width="80">
                        </router-link>
                </div>
            </div>

            <a style="float: left;margin-left: 50px;" role="button" @click="ShowBurgerMenu()" class="navbar-burger" aria-label="menu" aria-expanded="false">
                <div v-if="IsShowBurgerMenu">
                    <span aria-hidden="true">
                        <router-link class="navbar-item" :to="{ name: 'DashboardPage' }" active-class="is-active">Dashboard</router-link>
                    </span>
                </div>
            </a>


            <div class="navbar-menu">


                <div class="navbar-start">

                    <router-link class="navbar-item" :to="{ name: 'DashboardPage' }" active-class="is-active">Dashboard</router-link>

                    <div v-if="userPermissions.includes('Efb.Device') || userPermissions.includes('Efb.OccLogs')" class="navbar-item has-dropdown is-hoverable">

                        <a class="navbar-link">
                            EFB
                        </a>

                        <div class="navbar-dropdown is-boxed">
                            <router-link v-if="userPermissions.includes('Efb.Device')" class="navbar-item"
                                         :to="{ name: 'Efb' }">EFB Devices
                            </router-link>
                            <router-link v-if="userPermissions.includes('Efb.OccLogs')" class="navbar-item"
                                         :to="{ name: 'EFBOccSideLogs' }">Occ Logs
                            </router-link>
                        </div>

                    </div>

                    <router-link v-if="userPermissions.includes('Flights.View')" class="navbar-item"
                                 :to="{ name: 'Flights' }" active-class="is-active">Flights
                    </router-link>

                    <router-link v-if="userPermissions.includes('Schedule.ViewAll')" class="navbar-item"
                                 :to="{ name: 'Schedule',  params: {date: currentDate}}" active-class="is-active">Schedule
                    </router-link>

                    <router-link v-if="userPermissions.includes('Aircraft.Full')" class="navbar-item"
                                 :to="{ name: 'Aircrafts' }" active-class="is-active">Aircraft
                    </router-link>

                    <router-link class="navbar-item" :to="{ name: 'Library' }" active-class="is-active">Library
                    </router-link>

                    <div v-if="userPermissions.includes('Users.View')" class="navbar-item has-dropdown is-hoverable" active-class="is-active">
                        <a class="navbar-link">
                            User Management
                        </a>

                        <div class="navbar-dropdown is-boxed">
                            <router-link v-if="userPermissions.includes('Users.View')" class="navbar-item"
                                         :to="{ name: 'Users' }" active-class="is-active">Users
                            </router-link>
                            <router-link v-if="userPermissions.includes('UsersRole.Full')" class="navbar-item"
                                         :to="{ name: 'UserRoles' }">User Roles
                            </router-link>
                        </div>
                    </div>

<!--                    <div v-if="userPermissions.includes('Services.View')" class="navbar-item has-dropdown is-hoverable">-->
<!--                        <a class="navbar-link">-->
<!--                            Services-->
<!--                        </a>-->
<!--                        <div class="navbar-dropdown is-boxed">-->
<!--                            <router-link class="navbar-item" :to="{ name: 'Services' }">EFB Reports</router-link>-->
<!--                            <router-link class="navbar-item" :to="{ name: 'Services' }">Loadsheet</router-link>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div v-if="userPermissions.includes('Admin.BarView')" class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-link">
                            Admin
                        </a>
                        <div class="navbar-dropdown is-boxed">
                            <router-link v-if="userPermissions.includes('Airport.Full')" class="navbar-item"
                                         :to="{ name: 'Airport' }" active-class="is-active">
                                Airports
                            </router-link>
                            <router-link v-if="userPermissions.includes('WeatherMatrix.Full')" class="navbar-item"
                                         :to="{ name: 'WeatherMatrix' }" active-class="is-active">
                                Weather Matrix
                            </router-link>
                            <router-link v-if="userPermissions.includes('FIRs.Full')" class="navbar-item"
                                         :to="{ name: 'firs' }" active-class="is-active">
                                FIRs Manage
                            </router-link>
                            <router-link v-if="userPermissions.includes('Notifications.Full')" class="navbar-item"
                                         :to="{ name: 'Notifications' }" active-class="is-active">
                                Notifications
                            </router-link>
                            <router-link v-if="userPermissions.includes('IpadUsers.Full')" class="navbar-item"
                                         :to="{ name: 'IpadUserList' }" active-class="is-active">
                                Ipad Users
                            </router-link>

                            <router-link v-if="userPermissions.includes('ReportSummary.Full')" class="navbar-item"
                                         :to="{ name: 'ReportSummary', params: {date: currentDate}}" active-class="is-active">
                                Report Summary
                            </router-link>
                            <router-link v-if="userPermissions.includes('ArchiveSummary.Full')" class="navbar-item"
                                         :to="{ name: 'ArchiveSummary' }" active-class="is-active">
                                Archive Summary
                            </router-link>
                          <router-link :to="{name:'WXBriefingGenerator'}" class="navbar-item block"><span>WX Briefing Generator</span>&nbsp;<span
                              class="tag is-success">New!</span></router-link>
                        </div>
                    </div>
<!--                    <div>{{OnlineStat}}||{{showBackOnline}}</div>-->
                    <div class="navbar-item">
                        <p v-if="IsProdEnvMode!=true" style="padding:8px; text-align: center; background-color: red; color: white; font-weight: bold;" class="box">Development Test Environment Mode is Active</p>
                    </div>
                </div>

                <div class="navbar-end">
                    <div class="notify-header" style="padding-right: 16px;">
                        <div style="text-align: right; padding-right: 15%; padding-top: 0px;">
                            <div class="NotifyTooltips">
                                <div>
                                    <span>
                                     <p style="color: dodgerblue;">{{NotifiesLength}}</p>
                                    </span>
                                    <span>
                                    <font-awesome-icon icon="bell" size="2x"
                                                       color="dodgerblue"
                                                       @click="NotifyBellControl()"
                                                       style="cursor: pointer; margin-top: 0px;"
                                                       title="Go to Notifications"/>
                                    </span>
                                 </div>
                            </div>
                        </div>

                        <div>
                            <div class="columns">
                                <div class="column">
                                    <div class="level level-right">
                                        <div style="margin-left: 200px;margin-right: 400px; background-color: #f0f0f0; position: absolute; max-height: 200px; margin-top: 200px; z-index: 999;background-color: #f0f0f0;">
                                            <div style="overflow-y:scroll;height: 400px; scrollbar-width:2px; min-width: 800px; max-width: 1000px; border-style: solid; background-color: #f0f0f0;" v-if="NotifyDetailsVisible">
                                                <div class="stickyhead">
                                                    <span class="closebtn" @click="NotifyDetailsControl()">&times;</span><p style="font-weight: bold">Notify Details</p><br/>
                                                </div>
                                                <!--<table class="table is-hoverable is-narrow is-striped">-->
                                                <!-- table is-fullwidth is-narrow is-striped is-bordered animate__animated animate__slideInUp -->

                                                <table class="table is-hoverable is-narrow is-striped is-bordered animate__animated animate__slideInUp">

                                                    <thead>
                                                        <tr style="position: sticky;">
                                                            <th>Notify Region</th>
                                                            <th>First Notify DT</th>
                                                            <th>Last Notify DT</th>
                                                            <th>Notify Text</th>
                                                            <th>FMESSAGE</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody v-if="this.NotifyDetails && this.NotifyDetails.length" >
                                                        <tr v-for="notifyD in NotifyDetails" :key="notifyD.id">
                                                            <td>{{notifyD.notifyRegion}}</td>
                                                            <td>{{notifyD.firstNotifyDT|longFormatFromDT}}</td>
                                                            <td>{{notifyD.lastNotifyDT|longFormatFromDT}}</td>
                                                            <td>{{notifyD.notifyText}}</td>
                                                            <td>{{notifyD.fmessage}}</td>
                                                        </tr>
                                                    </tbody>

                                                    <div v-else>
                                                        <p>Not found Detail List of Notify.</p>
                                                    </div>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="column">
                                    <div class="level level-right">
                                        <div style="text-align: right; padding-right: 0; background-color: #f0f0f0; position: absolute; max-height: 200px; margin-top: 200px; z-index: 999">
                                            <div style="overflow-y:scroll;height: 850px; scrollbar-width: 2px; border-style: solid" v-if="NotifyVisible">

                                                    <div class="stickyhead">
                                                        <span class="closebtn" @click="NotifyControl()">&times;</span><p style="font-weight: bold">Notifies</p><br/>
                                                    </div>
                                                    <div v-for="(post, index) in newnotifies" :key="index">
                                                    <div class="NotifyTooltipTexts" v-if="NotifyVisible">
                                                        <div style="font-size: small" class="notification is-light">

                                                            <div class="columns">

                                                                <div class="column is-narrow">
                                                                    <font-awesome-icon icon="arrow-left" size="1x" color="red" @click="GetDetailsOfNotify(post.summarY_ID)" style="cursor: pointer" title="Go to Notify Details"/>
                                                                </div>

                                                                <div class="column">
                                                                    <br/>
                                                                    <p>{{post.fKeyForZip}}</p>
                                                                    <p>{{post.adep+"-"+post.aarr}}</p><br/>
                                                                </div>

                                                                <div class="column is-narrow">

                                                                        <div v-if="post.warningCOunt != 0" class="level-item has-text-centered" style="padding: 3px; margin-right: 0px;">
                                                                            <div style="backgroundColor : orange;">
                                                                                <p class="heading notifyStatus" style="color:white">{{post.warningCOunt.toString().padStart(2, '0')}}</p>
                                                                            </div>
                                                                        </div>

                                                                        <div v-if="post.errorCOunt != 0" class="level-item has-text-centered" style="padding: 3px;margin-right: 0px;">
                                                                            <div style="backgroundColor : red;">
                                                                                <p class="heading notifyStatus" style="color:white">{{post.errorCOunt.toString().padStart(2, '0')}}</p>
                                                                            </div>
                                                                        </div>

                                                                        <div class="level-item has-text-centered" style="padding: 3px;margin-right: 0px;">
                                                                            <div style="backgroundColor : green;">
<!--                                                                                post.CNT-->
                                                                                <p class="heading notifyStatus" style="color:white">{{Sum(post.errorCOunt,post.warningCOunt,post.cnt)}}</p>
                                                                            </div>
                                                                        </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>

                        </div>
                    </div>

                    <div class="navbar-item">
                        <eff-upload-modal />
                    </div>

                    <div class="navbar-item has-dropdown is-hoverable">

                        <a class="navbar-link">
                            <small>{{user.full_name}}</small>
                        </a>

                        <div class="navbar-dropdown is-right">
                            <a class="navbar-item" @click="getUserProfile">
                                <span class="icon"><font-awesome-icon icon="user"/></span>
                                <span><strong>Profile</strong></span>
                            </a>
                            <hr class="navbar-divider">
                            <a class="navbar-item" @click="logout">
                                <span class="icon"><font-awesome-icon icon="power-off"/></span>
                                <span><strong>Logout</strong></span>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </nav>
    </div>

</template>
<script>
import {mapActions, mapState} from "vuex";
import EffUploadModal from "@/components/ui/EffUploadModal";

// import * as moment from "moment";

        export default {
            name: "AppHeader",

            components: {
                EffUploadModal,
            },

            data() {
                return {
                        userPermissions: [],
                        efbStatus: "Efb.Status",
                        NotifyVisible : false,
                        NotifyDetailsVisible : false,

                        LastId : 0,
                        oldLastId : 0,
                        NotifiesLength : 0,
                        newnotifies:[],
                        tmpNotifies:[],
                        notifyDetails: [],
                        currentDate : '',

                        OnlineStat : navigator.onLine ? true:false,
                        showBackOnline:null,

                        IsProdEnvMode:false,

                        IsShowBurgerMenu : false,
                }

        },

        computed: {

            ...mapState("auth", ["user","IsProdEnvironment"]),
            ...mapState("appheader",["NotifyDetails"]),

            NotifyBackground:
            {
                get()
                {
                    if( this.NotifyVisible == true || this.NotifyDetailsVisible == true )
                    {

                        return true;
                    }
                    else
                    {
                        return false;
                    }
                }
            },

        },

        methods: {

            ...mapActions("auth", ["logout","getIsProdEnvironment"]),
            ...mapActions("appheader",["GetNewNotifies","GetNotifyDetails"]),

            getUserProfile() {
                this.$router.push({name: "UsersProfile", params: {permissions: this.userPermissions}});
            },

            ShowBurgerMenu()
            {
              this.IsShowBurgerMenu = !this.IsShowBurgerMenu;
            },

            async GetNotifies(LastId)
            {
                console.log(LastId);
                // try
                // {

                //         this.newnotifies    = await this.GetNewNotifies(LastId);
                //         this.LastId         = this.newnotifies[0].lastid;
                //         this.NotifiesLength = this.newnotifies.length;
                //         this.oldLastId      = this.LastId;

                // }
                // catch (e) {
                //      this.$notify({title: "Error", text: "Error on GetNotifies functions "+ e.message, type: "error"});
                // }
            },



            async CheckGetNotifies(LastId)
            {

                try
                {
                    this.tmpNotifies = await this.GetNewNotifies(LastId);
                    console.log("Length: " + this.tmpNotifies.length);
                }
                catch(e)
                {
                    //this.$notify({title: "Error", text:"Couldn't access Eff server. Please check your internet connection." , type: "error"});
                }

                try
                {

                    if (this.tmpNotifies.length == 0)
                    {
                        return;
                    }
                    else
                    {
                        this.LastId = this.tmpNotifies[0].lastid;
                    }

                    if(this.oldLastId < this.LastId)
                    {

                        for (var i = 0; i < this.tmpNotifies.length; i++)
                        {

                            var matchednotify = this.newnotifies.findIndex(x => x.summarY_ID == this.tmpNotifies[i].summarY_ID);

                            if(matchednotify != -1)
                            {
                                this.newnotifies[matchednotify] = this.tmpNotifies[i];
                            }
                            else
                            {
                                this.newnotifies.unshift(this.tmpNotifies[i]);
                            }
                        }
                        this.oldLastId = this.LastId;
                        this.NotifiesLength += this.tmpNotifies.length;
                    }

                    this.tmpNotifies.length = 0;
                }
                catch(e)
                {
                     //this.$notify({title: "Error", text:"Error on GetNotifyDetails, "+ e.message, type: "error"});
                }


            },

            async GetDetailsOfNotify(SummaryId)
            {
                try {

                        this.notifyDetails = await this.GetNotifyDetails(SummaryId);
                        this.NotifyDetailsVisible = true;
                }
                catch (e) {

                        //this.$notify({title: "Error", text:"Error on GetNotifyDetails, "+ e.message, type: "error"});

                }
            },

            NotifyBellControl()
            {
                this.NotifyVisible = !this.NotifyVisible;

                if(this.NotifyVisible)
                {
                    this.NotifiesLength = 0;
                }
            },

            NotifyDetailsControl()
            {
                this.NotifyDetailsVisible = false;
            },

            NotifyControl()
            {
                this.NotifyVisible = false;
                this.NotifyDetailsVisible = false;
            },

            Sum(val,val2,CNT)
            {
               return (CNT-(val+val2)).toString().padStart(2, '0');
            }

        },

         async created() {

            await this.getIsProdEnvironment();
            this.IsProdEnvMode=this.IsProdEnvironment;

            this.currentDate = new Date().toISOString().slice(0, 10);
            this.userPermissions = this.user.permissions;

            // Notify işlemlerinin başta yüklendiği kısım.
            var Lid = this.LastId;
            await this.GetNotifies(Lid);

            setInterval(async () =>
            {
                // LastId başlangıçta 0 olacak şekilde parametre gönderilecek.
                // Gelen notify listesinin ilk elemanı eklenmiş lastid olarak kayda alınacaktır.
                // Gelen notify listesinin balonlara doldurulmasıdır.

                // burada login olmadan öncede çalışabilmektedir. login varsa çalıştırsın...

                if(this.user!= null){
                        var Lid = this.LastId;
                        await this.CheckGetNotifies(Lid);
                }
                // this.GetNotifies(this.LastId);

            }, 25000);  // 25000
        },


    }
</script>

<style scoped>

    thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .stickyhead{
        padding-top: 13px;
        color: black;
        background-color: #e0e0e0;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;

    }

    .notifyStatus{
        font-size: 15px;
        padding: 4px;
    }

    .notification
    {
        border-style:groove;
        border-width: 2px;
        /*margin-bottom: 5px;*/
        background-color: #fffdfd;
    }

    .NotifyTooltips .NotifyTooltipTexts
    {

        /*visibility: hidden;*/
        width: 420px;
        background-color: #fff;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        margin-top: 5px;
        border-color: #4f4f4f;
        padding: 10px 0;
        /* Position the tooltip */
        position: absolute;
        z-index: 999;

    }

    .closebtn
    {
        margin-left: 15px;
        color: blue;
        font-weight: bold;
        float: right;
        font-size: 28px;
        line-height: 20px;
        cursor: pointer;
        transition: 0.3s;
    }

    .Notify.relative{
        position:relative;

    }

    .notify.absolute{
        position:absolute;
    }

    .notify-header{
        display: none;
    }
</style>
